<script setup lang="ts">
import { Bell } from '@element-plus/icons-vue'
import { useNotificationStore } from '@/stores/notifications'
import { useAuth } from '@/composables/useAuth'
import { hasAdminRole } from '@/types/auth'
import { computed } from 'vue'

const store = useNotificationStore()
const { state } = useAuth()

// 管理员不显示用户端通知角标
const showBadge = computed(() => !hasAdminRole(state.currentUser?.role))
</script>

<template>
  <RouterLink
    v-if="showBadge"
    to="/messages"
    class="relative flex items-center justify-center rounded-lg p-2 transition hover:bg-[var(--color-card-bg)]"
  >
    <ElIcon size="20" class="text-[var(--color-body)]">
      <Bell />
    </ElIcon>
    <span
      v-if="store.unreadTotal > 0"
      class="absolute right-1 top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-[var(--color-danger)] px-1 text-[10px] font-medium text-white"
    >
      {{ store.unreadTotal > 99 ? '99+' : store.unreadTotal }}
    </span>
  </RouterLink>
</template>
